import { GlobalAdapter } from "@core/store/adapters/global.adapter";
import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";

import { AutocompleteResponse, LocationState } from "@core/entities";
import * as LocationAction from "@core/store/actions/location.action";
import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";

interface LocationReducerState extends LocationState, EntityState<AutocompleteResponse> {}

function suggestionAdapterSelectId(pp: AutocompleteResponse): string {
  return pp.place_id;
}

export const suggestionAdapter: EntityAdapter<AutocompleteResponse> = createEntityAdapter<AutocompleteResponse>({
  selectId: suggestionAdapterSelectId,
  sortComparer: (ppA, ppB) => (ppA.index > ppB.index ? 1 : -1),
});

const initialState: LocationReducerState = suggestionAdapter.getInitialState({
  detailResult: null,
  ui: {
    loadingResults: false,
    noResults: false,
  },
} as LocationState);

const globalReducerCreate = createReducer(
  initialState,
  on(LocationAction.clearAll, () => initialState),
  on(LocationAction.setAutocompleteResponses, (state, { suggestions }) => suggestionAdapter.setAll(suggestions, state)),
  on(LocationAction.setDetailResponse, (state, { details }) => ({ ...state, detailResult: details })),
  on(LocationAction.uiLocation, (state, { ui }) => GlobalAdapter.setUi(ui, state))
);

export function LocationReducer(state: LocationReducerState, action: Action) {
  return globalReducerCreate(state, action);
}

export const getLocation = createFeatureSelector<LocationReducerState>("location");

// entity selectors
export const { selectAll: selectSuggestionsArray } = suggestionAdapter.getSelectors(getLocation);
export const selectSuggestionEntities = createSelector(getLocation, state => state.entities);

export const getUiLocation = createSelector(getLocation, ({ ui }) => ui);
export const getDetailResponse = createSelector(getLocation, ({ detailResult }) => detailResult);
